import {ALL_SEASONS_TIRES, SUMMER_TIRES, WINTER_TIRES} from "./Constants";

export function localizeType(type) {
    switch (type) {
        case SUMMER_TIRES: return 'Летни'
        case WINTER_TIRES: return 'Зимни'
        case ALL_SEASONS_TIRES: return 'Всесезонни'
    }
    return 'Неизвестно'
}